module.exports = __webpack_public_path__ + "static/media/error.f219d2a6.svg";